import makeCreateElement from './makeCreateElement'

export default makeCreateElement
